module.exports = __webpack_public_path__ + "static/media/features-split-image-03.87e4d053.png";